import { useParams } from "react-router-dom";
import ResourceEditor from "components/cms/ResourceEditor";
import CaseStack from "components/cms/CaseStack";
import {
  addCustomerCase,
  emptyCustomerCase,
  getCustomerCase,
  prepareCustomerCase,
  updateCustomerCase,
} from "api/customercase";

export default function CaseEditPage() {
  const { id } = useParams();
  const isNew = !id || id === "new";

  return (
    <ResourceEditor
      id={id}
      isNew={isNew}
      empty={emptyCustomerCase}
      load={getCustomerCase}
      create={addCustomerCase}
      update={updateCustomerCase}
      prepare={prepareCustomerCase}
      listHref="/admin/cases"
      label="case"
    >
      {(props) => <CaseStack {...props} />}
    </ResourceEditor>
  );
}
